import dayjs from "dayjs";

import { Box, Grid, Typography, useTheme } from "@mui/material";

import { formatDate } from "@aclymatepackages/formatters";

import { useLayoutHelpers } from "../../../helpers/otherHelpers";
import { useWorkDayHeightPx } from "../../../helpers/components/inputs";
import { useSurveyLanguage } from "../../../helpers/contexts/surveyLanguage";

const CommuteDaysColumn = ({ daysPerWk }) => {
  const theme = useTheme();
  const { isMobile } = useLayoutHelpers();
  const workDayHeightPx = useWorkDayHeightPx();
  const { translate } = useSurveyLanguage();

  return (
    <Box display="flex" flexDirection="column-reverse" position="relative">
      {[...new Array(7)].map((_, idx) => {
        const isFullWorkDay = daysPerWk - idx >= 1;
        const isPartialDay = daysPerWk - idx > 0 && daysPerWk - idx < 1;

        return (
          <Box
            key={`commute-day-${idx}`}
            style={{
              backgroundColor: !daysPerWk
                ? "rgba(0, 0, 0, 0.62)"
                : isFullWorkDay
                  ? theme.palette.employees.main
                  : theme.palette["business-travel"].main,
              height: `${workDayHeightPx}px`,
              width: "100%",
              color: "white",
              border: "thin solid white",
              boxSizing: "border-box",
              padding: theme.spacing(0, isMobile ? 1 : 2)
            }}
            position="relative"
            display="flex"
            justifyContent="center"
            alignItems="center"
            p={1}
          >
            {isPartialDay && (
              <Box
                position="absolute"
                style={{
                  backgroundColor: theme.palette.employees.main,
                  width: "100%",
                  height: `${workDayHeightPx * (daysPerWk - idx)}px`,
                  bottom: 0
                }}
              />
            )}
            <Typography
              variant={isMobile ? "body2" : "subtitle1"}
              color="inherit"
              style={{ position: "relative", zIndex: 9999 }}
            >
              {translate("commute.day", { num: idx + 1 })}
            </Typography>
          </Box>
        );
      })}
    </Box>
  );
};

const WorkspaceGraphicCard = ({
  employeeName = "",
  endDate,
  startDate,
  daysPerWk,
  graphic,
  actions
}) => {
  const { isMobile } = useLayoutHelpers();
  const { translate } = useSurveyLanguage();

  const firstName = employeeName.split(" ")[0];

  const buildTitle = () => {
    if (!endDate || dayjs(endDate).isSame(dayjs(), "day")) {
      return translate("commute.currentWeeklyCommute", { firstName });
    }

    if (startDate && endDate) {
      return translate("commute.weeklyCommuteFromTo", {
        firstName,
        startDate: formatDate(startDate),
        endDate: formatDate(endDate)
      });
    }

    return translate("commute.weeklyCommuteBefore", {
      firstName,
      endDate: formatDate(endDate)
    });
  };

  return (
    <>
      <Grid container direction="column" spacing={isMobile ? 0 : 1}>
        <Grid
          item
          container
          alignItems="center"
          wrap="nowrap"
          justifyContent="space-between"
        >
          <Grid item>
            <Typography variant={isMobile ? "body2" : "subtitle1"}>
              {buildTitle()}
            </Typography>
          </Grid>
          {actions && (
            <Grid item>
              <Grid container wrap="nowrap" alignItems="center">
                {actions.map((action, idx) => (
                  <Grid key={`workspace-edit-card-${idx}`} item>
                    {action}
                  </Grid>
                ))}
              </Grid>
            </Grid>
          )}
        </Grid>
        <Grid item container>
          <Grid item xs={2}>
            <CommuteDaysColumn daysPerWk={daysPerWk} />
          </Grid>
          <Grid item xs={10}>
            {graphic}
          </Grid>
        </Grid>
      </Grid>
    </>
  );
};
export default WorkspaceGraphicCard;
